/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */
import { Component } from '@angular/core';

/**
 * Visual component for dividing sections of the family member view.
 */
@Component({
  selector: 'family-divider',
  templateUrl: './family-member-divider.component.html',
  standalone: false,
})
export class FamilyMemberDividerComponent {}
